export var TransferType;
(function (TransferType) {
    TransferType["Internal"] = "internal";
    TransferType["External"] = "external";
    TransferType["Withdraw"] = "withdraw";
    TransferType["Deposit"] = "deposit";
})(TransferType || (TransferType = {}));
